import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-http-response-modal',
  templateUrl: './http-response-modal.component.html',
  styleUrls: ['./http-response-modal.component.scss'],
})
export class HTTPResponseModalComponent {
  @Input() status: number = 200;
  @Input() message: string = '';
  
  get statusIcon(): string {
    return this.status === 200 ? 'checkmark-circle-outline' : 'close-circle-outline';
  }
  
  get statusColor(): string {
    return this.status === 200 ? 'success' : 'danger';
  }

  constructor(private modalController: ModalController) { }

  onClose() {
    this.modalController.dismiss(null, 'cancel');
  }
}
